module.exports = __webpack_public_path__ + "static/media/kategoria @1x.fdd682a5.jpg";